<template>
  <div class="bg-white size-full">
    <header
      class="sticky top-0 flex justify-between items-center pl-4 py-0.5 pr-0.5 border-b border-gray-200"
    >
      <div class="flex gap-x-2">
        <p class="font-medium text-sm text-gray-900">
          {{ t("common.components.backgroundProcess.title") }}
        </p>
        <span class="badge-light-gray-sm"> {{ jobs?.length ?? 0 }} </span>
      </div>
      <div class="flex">
        <button
          class="btn-additional-md hidden md:block"
          @click.stop="emit('toogle:expand', !isExpanded)"
        >
          <ArrowsPointingInIcon v-if="isExpanded" />
          <ArrowsPointingOutIcon v-else />
        </button>
        <button
          class="btn-additional-md text-gray-900"
          @click.stop="emit('close:panel')"
        >
          <XMarkIcon />
        </button>
      </div>
    </header>
    <ul>
      <ProcessListRow v-for="job in jobs" :key="job.code" :job="job" />
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
  XMarkIcon,
} from "@heroicons/vue/20/solid";
import ProcessListRow from "./ProcessListRow.vue";
import { inject, onUnmounted, ref } from "vue";
import { jobsKey } from ".";
import { useI18n } from "vue-i18n";

defineProps<{ isExpanded: boolean }>();
const emit = defineEmits<{
  "toogle:expand": [expand: boolean];
  "close:panel": [];
}>();

const { t } = useI18n();
const jobs = inject(jobsKey, ref<Auth.JobUI[]>([]));

onUnmounted(() => emit("toogle:expand", false));
</script>
